import { configureStore } from '@reduxjs/toolkit';
import authSlice from './slices/authSlice';
import clientSlice from './slices/clientSlice';
import serviceSlice from './slices/serviceSlice';
import contractSlice from './slices/contractSlice';
import templateSlice from './slices/templateSlice';
import dashboardSlice from './slices/dashboardSlice';
import uiSlice from './slices/uiSlice';
import errorMiddleware from './middleware/errorMiddleware';

export const store = configureStore({
  reducer: {
    auth: authSlice,
    clients: clientSlice,
    services: serviceSlice,
    contracts: contractSlice,
    templates: templateSlice,
    dashboard: dashboardSlice,
    ui: uiSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }).concat(errorMiddleware),
});

export default store;